import { createContext, useState } from "react";

export const ModalContext = createContext<any>({
  open: false,
});

export const ModalProvider = ({ children } : any) => {
  const [isOpen, setOpen] = useState<any>(false);
  const [isLoginOpen, setLoginOpen] = useState<any>(false);

  return <ModalContext.Provider value={{
    isOpen,
    setOpen,
    isLoginOpen,
    setLoginOpen,
  }}>{children}</ModalContext.Provider>
};
